var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"header"},[_c('p',{staticClass:"name"},[_vm._v("WebSocket Mock")]),_vm._v(" "),_c('p',{staticClass:"add",on:{"click":_vm.requestAddSession}},[_vm._v("+")])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1abcd49c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/wsmock/components/card.vue
// module id = 417
// module chunks = 2